/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgManageExtension = (props: Props) => (
  <Icon viewBox="0 0 24 23" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13.352 3.93a8.295 8.295 0 0 0-5.405.947c-1.63.918-2.867 2.358-3.494 4.066l-1.886-.636c.783-2.135 2.33-3.935 4.366-5.082s4.43-1.566 6.758-1.183 4.438 1.542 5.96 3.273c.12.138.237.279.349.422V3.833h2v7.668l-2-.001v-.025a7.478 7.478 0 0 0-1.88-4.925 8.085 8.085 0 0 0-4.768-2.62zM4 11.525a7.478 7.478 0 0 0 1.88 4.925 8.086 8.086 0 0 0 4.768 2.62 8.296 8.296 0 0 0 5.406-.947c1.628-.918 2.866-2.358 3.493-4.066l1.886.636c-.783 2.135-2.33 3.935-4.366 5.082a10.37 10.37 0 0 1-6.758 1.183c-2.327-.382-4.438-1.542-5.96-3.273A9.682 9.682 0 0 1 4 17.262v1.904H2v-7.668l2 .001z" />
        <path d="M8 7h8v9H8zm2 5v2h4v-2zm0-2h4V9h-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgManageExtension as ManageExtension };
